import { createContext } from "react";

import PopUp from "common/blocks/PopUp";
import Sidebar from "common/blocks/Sidebar";
import Toast from "common/blocks/Toast";

import usePopupHook from "./usePopup";
import type { IUsePopup } from "./usePopup";
import useSidebarHook from "./useSidebar";
import type { IUseSidebar } from "./useSidebar";
import useToastHook from "./useToast";
import type { IUseToast } from "./useToast";

type ModalContextProps = {
    useSidebar: () => IUseSidebar;
    usePopup: () => IUsePopup;
    useToast: () => IUseToast;
} | null;

type ModalProviderProps = {
    children: React.ReactNode;
};

export const ModalContext = createContext<ModalContextProps>(null);

const ModalProvider = ({ children }: ModalProviderProps) => {
    const useSidebar = useSidebarHook();
    const usePopup = usePopupHook();
    const useToast = useToastHook();

    return (
        <>
            <ModalContext.Provider
                value={{
                    usePopup: () => usePopup,
                    useSidebar: () => useSidebar,
                    useToast: () => useToast,
                }}
            >
                {children}
                <Sidebar />
                <PopUp />
                <Toast />
            </ModalContext.Provider>
            <div id="sidebar-root"></div>
            <div id="popup-root"></div>
            <div id="toast-root"></div>
        </>
    );
};

export default ModalProvider;
